import { render, staticRenderFns } from "./UpdateGiftsDialog.vue?vue&type=template&id=4682410b&scoped=true&"
import script from "./UpdateGiftsDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateGiftsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682410b",
  null
  
)

export default component.exports